import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleFooterLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    
    const isOnHomePage = location.pathname === '/';
    
    if (isOnHomePage) {
      // If on home page, just scroll to section
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If not on home page, navigate to home first, then scroll after navigation
      navigate('/', { state: { scrollTo: hash } });
    }
  };

  // Handle scrolling after navigation
  useEffect(() => {
    if (location.state && (location.state as any).scrollTo) {
      const hash = (location.state as any).scrollTo;
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      // Clear the state to prevent scrolling on every render
      window.history.replaceState({}, '', location.pathname);
    }
  }, [location]);

  return (
    <footer className="footer gray-wave">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-brand">
              <Link to="/" className="footer-logo-link">
                <div className="footer-logo">
                  <img src="/images/logo.png" alt="Basant Kumar Verma Logo" className="footer-logo-image" />
                </div>
              </Link>
              <Link to="/" className="footer-brand-link">
                <h4 className="footer-brand-name">Basant Kumar Verma</h4>
              </Link>
              <p className="footer-brand-title">Salesforce Solution Architect</p>
              <p className="footer-brand-desc">
                Expert in Salesforce development, solution architecture, and team leadership.
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links">
              <li><a href="#about" onClick={(e) => handleFooterLinkClick(e, '#about')}>About Me</a></li>
              <li><a href="#career" onClick={(e) => handleFooterLinkClick(e, '#career')}>IT Career</a></li>
              <li><a href="#testimonials" onClick={(e) => handleFooterLinkClick(e, '#testimonials')}>Testimonials</a></li>
              <li><a href="#content" onClick={(e) => handleFooterLinkClick(e, '#content')}>Content</a></li>
              <li><a href="#contact" onClick={(e) => handleFooterLinkClick(e, '#contact')}>Contact</a></li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="footer-section">
            <h5 className="footer-heading">Connect</h5>
            <div className="footer-social">
              <a 
                href="tel:+917014213304" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                Phone
              </a>
              <a 
                href="mailto:contact@basantverma.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                Email
              </a>
              <a 
                href="https://www.linkedin.com/in/basantverma1990/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="LinkedIn"
              >
                LinkedIn
              </a>
              <a 
                href="https://trailblazer.me/id/basantverma1990" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Trailhead"
              >
                Trailhead
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Basant Kumar Verma. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

